/** Google Maps options that disable pan/zoom so the map view stays fixed. */
export const lockedGoogleMapOptions = {
  disableDefaultUI: true,
  gestureHandling: "none",
  scrollwheel: false,
  disableDoubleClickZoom: true,
  draggable: false,
  keyboardShortcuts: false,
  zoomControl: false
}
